import { cardsData } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            精选推荐
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            精选高分热门综艺，总有一档适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cardsData.slice(0, 7).map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors group flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-primary-600 text-xs font-semibold">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-bold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2 flex-1">
                  {item.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <button className="text-xs text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                    立即观看
                    <i className="ri-arrow-right-s-line ml-0.5"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}